/**
 * Formats a date string for notification display
 * @param dateString - The date string to format
 * @returns Formatted date string in format "MMM d, yyyy h:mm a"
 */
export function formatNotificationDate(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric', 
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  
  return date.toLocaleDateString('en-US', options);
}

/**
 * Normalizes a period date value to API format YYYY-MM-DD.
 * Supports Date, Moment-like objects, ISO strings and DD/MM/YYYY.
 */
export function normalizePeriodDate(value: unknown): string | null {
  if (!value) return null;

  let date: Date;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'object') {
    const m = value as any;
    date = typeof m.toDate === 'function' ? m.toDate() : new Date(m);
  } else if (typeof value === 'string') {
    const v = value.trim();
    const standardized = v.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, '$3-$2-$1');
    date = new Date(standardized);
  } else {
    return null;
  }

  if (isNaN(date.getTime())) return null;

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  
  return `${y}-${m}-${d}`;
}
